/**
 * Resize function without multiple trigger
 * 
 * Usage:
 * $(window).smartresize(function(){  
 *     // code here
 * });
 */
 (function($,sr){
    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    let debounce = function (func, threshold, execAsap) {
      let timeout;

        return function debounced () {
            let obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args); 
                timeout = null; 
            }

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100); 
        };
    };

    // smartresize 
    jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');
/**
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var THEME_CURRENT_URL = window.location.href.split('#')[0].split('?')[0];

// Sidebar
function init_sidebar() {
    $('.nav-item-title').css('font-size', '8px');
    $('body').attr('class', 'nav-sm');
    $('body').css('opacity', 1);
    $('.childs_parent').each(function (){
        if ($(this).children().length == 0) {
            $(this).remove();
        }
    });

    // TODO: This is some kind of easy fix, maybe we can improve this
    let setContentHeight = function () {
        // reset height
        $('.right_col').css('min-height', $(window).height());

        let bodyHeight = $('body').outerHeight(),
            footerHeight = $('body').hasClass('footer_fixed') ? -10 : $('footer').height(),
            leftColHeight = $('.left_col').eq(1).height() + $('.sidebar-footer').height(),
            contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

        // normalize content
        contentHeight -= $('.nav_menu').height() + footerHeight;

        $('.right_col').css('min-height', contentHeight);
    };

    // check active menu
    $('#sidebar-menu').find('a[href="' + THEME_CURRENT_URL + '"]').parent('li').addClass('current-page');
    $('#sidebar-menu').find('a').filter(function () {
        return this.href == THEME_CURRENT_URL;
    }).parent('li').addClass('current-page').parents('ul').slideDown(function () {
        setContentHeight();
    }).parent().addClass('active');

    // recompute content when resizing
    $(window).smartresize(function () {
        setContentHeight();
    });

    setContentHeight();

    // fixed sidebar
    if ($.fn.mCustomScrollbar) {
        $('.menu_fixed').mCustomScrollbar({
            'autoHideScrollbar': true,
            'theme': 'minimal',
            'mouseWheel': { 'preventDefault': true }
        });
    }
}
// /Sidebar


$(function(){
    init_sidebar();
});	
